import loadBasketModule from './modules/Basket.module';
import loadWishListModule from './modules/WishList.module';
const ShopTheLook = () => ({
    hasRouter: false,
    modules: [loadBasketModule(), loadWishListModule()],
});
export default ShopTheLook;
